<template>
    <div class="overflow-auto">
        <b-container fluid class="bv-example-row">
            <b-modal
                id="bv-modal-view-firmware"
                header-bg-variant="dark"
                header-text-variant="light"
                body-bg-variant="dark"
                body-text-variant="light"
                hide-footer
            >
                <template v-slot:modal-title>
                    {{$t('firmware.view.title')}}
                </template>
                <Info v-if="firmwareViewId !== null" :id="firmwareViewId" />
            </b-modal>
            <b-row>
                <b-col md="4">
                </b-col>
                <b-col md="2">
          <span class="text-nowrap">
                        {{$t('firmwares_selected')+ ': ' + rows}}
                    </span>
                </b-col>
                <b-col md="4" offset-md="2">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-container>
        <div v-if="loadError" class="text-danger firmware-load-error">{{$t('firmware_load_error')}} <b-button @click="$refs.catalog.refresh()">{{$t('retry')}}</b-button></div>
        <b-table
                ref="catalog"
                v-if="!tableIsBusy"
                dark
                id="my-table"
                :items="myProvider"
                :per-page="perPage"
                :current-page="currentPage"
                :hover="hover"
                head-variant="dark"
                small
                @row-selected="onRowSelected"
                :fields="fields"
                no-local-sorting
                :filter="filters"
                :filterIncludedFields="filterOn"
                stacked="md"
                :filter-function="onFilter"
                striped
                 sort-by="createdAt"
                 sort-desc
        >
            <template v-slot:head()="scope">
                <div class="text-nowrap">
                    {{scope.label}}
                </div>
            </template>

            <template v-slot:cell(version)="row">
                <b-button variant="link" class="firmware-view" @click="openView(row)">{{row.item.version}}</b-button>
            </template>
            <template v-slot:cell(settings)="row">
                <FirmwareDownload :firmware="row.item" />
            </template>
            <template v-slot:cell(description)="row">
                <div
                    v-b-popover.hover.top="row.item.description"
                    class="word-wrap: break-word;min-width: 160px;max-width: 160px;"
                >
                    {{row.item.description}}
                </div>
            </template>
            <template slot="thead-top" slot-scope="{ fields }">
                <td v-for="field in fields" :key="field.key">
                    <div v-if="field.filteredType === 'select'">
                        <b-form-select
                            v-if="field.filtered === true"
                            v-model="filters[field.key]"
                            :style="{width: field.width + 'px'}"
                            :options="getDictionary(field.dictionaryName)"
                            value-field="id"
                            text-field="name"
                        />

                    </div>
                    <div v-else>
                        <b-input
                            v-if="field.filtered === true"
                            v-model="filters[field.key]"
                            :placeholder="$t(field.label)"
                            :style="{width: field.width + 'px'}"
                            :min="field.min"
                            :max="field.max"
                        />
                    </div>
                </td>
            </template>
        </b-table>
    </div>
</template>

<script>
    import axios from 'axios';
    import {brandConfig} from '../../config/brand';

    import Info from "./Info";
    import FirmwareDownload from "./FirmwareDownload.vue";

    export default {
        name: "FirmwareList",
        components: {
            Info, FirmwareDownload,
        },
        data() {
            return {
                tableIsBusy: true,
                loadError: false,
                filter: null,
                filterOn: [],
                isBusy: true,
                perPage: Math.floor(document.documentElement.clientHeight/44),
                currentPage: 1,
                deviceTypeList: [],
                rows: 0,
                firmwareViewId: null,
                fields: [],
                fieldsAvailable: [
                    {
                        key: 'settings',
                        label: 'firmware_list.coll.header.settings',
                        sortable: false,
                        stickyColumn: true
                    },
                    {
                        key: 'version',
                        label: 'firmware_list.coll.header.version',
                        sortable: true,
                        stickyColumn: true,
                        filtered: true,
                        width: 100,
                    },
                    {
                        key: 'deviceType',
                        label: 'firmware_list.coll.header.deviceTypeName',
                        sortable: true,
                        filtered: true,
                        filteredType: 'select',
                        dictionaryName: 'deviceType',
                    },
                    {
                        key: 'createdAt',
                        label: 'firmware_list.coll.header.createdAt',
                        sortable: true,
                        filtered: false,
                    },
                    ...(brandConfig.showFirmwareDescriptions ? [{
                        key: 'description',
                        label: 'firmware_list.coll.header.description',
                        sortable: false,
                        filtered: false,
                    }] : []),
                ],
                // items: [ ],
                small: true,
                bordered: true,
                hover: true,
                filters: {
                    name: null,
                    type: null,
                    distributor: null,
                    deviceType: null,
                },
                breadcrumb: [
                    {
                        text: 'Admin',
                        href: '#'
                    },
                    {
                        text: 'Manage',
                        href: '#'
                    },
                    {
                        text: 'Library',
                        active: true
                    }
                ],
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                }
            }
        },
        computed: {
            // rows() {
            //     return this.items.length
            // }
        },
        methods: {
            openView(row) {
                this.firmwareViewId = row.item.id;
                this.$bvModal.show('bv-modal-view-firmware')
            },
            closeView() {
                this.refreshTable();
                this.$bvModal.hide('bv-modal-view-firmware')
            },
            onFilter: function() {
                // alert(11);
              // console.log('onFilter');
            },
            onRowSelected(items) {
                this.selected = items
            },
            info(item, index, button) {
                this.infoModal.title = `Row index: ${index}`
                this.infoModal.content = JSON.stringify(item, null, 2)
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            onFiltered(filteredItems) {
                // console.log(this.filters)
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            myProvider (ctx) {
                // console.log(ctx)
                // Here we don't set isBusy prop, so busy state will be
                // handled by table itself
                let params = '?page='
                    + ctx.currentPage
                    + '&rows=' + ctx.perPage
                    + '&sortBy=' + ctx.sortBy
                    + '&sortOrder=' + (ctx.sortDesc ? 'desc': 'asc')

                for (let field in this.filters) {
                    if (this.filters[field] !== null) {
                        params += "&" + encodeURIComponent(field) + "=" + encodeURIComponent(this.filters[field]);
                    }
                }

                this.isBusy = true
                this.loadError = false;
                let promise = axios.get('api/v1/firmwares' + params)

                return promise.then((data) => {
                    const items = data.data.data
                    // Here we could override the busy state, setting isBusy to false
                    this.rows = data.data.records
                    this.isBusy = false

                    return(items)
                }).catch(error => {
                    this.isBusy = false;
                    if (error.response?.status !== 401) this.loadError = true;
                    // Here we could override the busy state, setting isBusy to false
                    // this.isBusy = false
                    // Returning an empty array, allows table to correctly handle
                    // internal busy state in case of error
                    // console.log(error)
                    return []
                })
            },
            getDictionary: function(type) {
                if (type=== 'deviceType') {
                    return this.deviceTypeList
                }

                return []
            },
            updateFields() {

                this.fields = [];
                this.fieldsAvailable.forEach(
                    column => {
                        column.label = this.$t(column.label)
                        this.fields.push(column);
                    }
                )

            },
        },
        mounted() {
            axios
                .get('api/v1/devices/device-types')
                .then((data) => {
                    this.deviceTypeList = [
                        {
                            id: null,
                            name: this.$t('select_type'),
                            selected: true
                        }
                    ]

                    this.deviceTypeList = this.deviceTypeList.concat(data.data.rows)
                    this.isBusy = false;
                })
                .catch(() => undefined);

            this.updateFields();

            this.tableIsBusy = false;
        }

    }
</script>

<style scoped>

</style>
